var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0.5625C2.32559 0.5625 0.5625 2.32559 0.5625 4.5C0.5625 6.67441 2.32559 8.4375 4.5 8.4375C6.67441 8.4375 8.4375 6.67441 8.4375 4.5C8.4375 2.32559 6.67441 0.5625 4.5 0.5625ZM6.05127 5.71025L5.7999 6.05303C5.79444 6.06049 5.78755 6.0668 5.77963 6.07159C5.77172 6.07639 5.76294 6.07957 5.75379 6.08096C5.74464 6.08235 5.73531 6.08191 5.72633 6.07968C5.71735 6.07746 5.7089 6.07347 5.70147 6.06797L4.24775 5.00801C4.2387 5.0015 4.23134 4.99292 4.22629 4.98298C4.22124 4.97304 4.21866 4.96203 4.21875 4.95088V2.53125C4.21875 2.49258 4.25039 2.46094 4.28906 2.46094H4.71182C4.75049 2.46094 4.78213 2.49258 4.78213 2.53125V4.70654L6.03545 5.6127C6.06709 5.63467 6.07412 5.67861 6.05127 5.71025Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.093763da7b9851a02c9fe88ce2c612f4.svg";
export { ForwardRef as ReactComponent };